import { UserProfile } from './models/user-profile.model';
import { DefaultAuthHeaders } from './models/default-auth-headers.model';
import { Observable } from 'rxjs';

// TODO This class is missing abstract methods used in AuthApiService
export abstract class AuthApiAbstract {
  public abstract async getCurrentUser(resetCache?: boolean): Promise<UserProfile>;

  public abstract async getJwt(): Promise<string>;

  public abstract async signOut(languageCode: string, countryCode: string): Promise<void>;

  public abstract loginWithSaml(): void;

  public abstract getDefaultAuthHeaders(): Promise<DefaultAuthHeaders>;

  public abstract listenForAuthAfterExternalSignin(): Observable<boolean>;
}
